export default { sha: '069776f11993823cb685cd90c1babd89233ad30f', buildNumber: 'undefined' }
